import {
  CloseIcon,
  SplitscreenStartIcon,
} from "@faro-lotv/app-component-toolbox";
import { FaroText, FaroTooltip, grey, ToggleButton } from "@faro-lotv/flat-ui";
import { Stack, SxProps } from "@mui/material";
import type { JSX } from "react";

type SplitScreenButtonProps = {
  /** True if this button should be enabled */
  enabled: boolean;

  /** True if this button is checked (split screen enabled) */
  checked: boolean;

  /** Callback called when the button is clicked */
  onClick(): void;

  /** Style for the button */
  sx?: SxProps;
};

/**
 * @returns A button to enable/disable split screen
 */
export function SplitScreenButton({
  enabled,
  checked,
  onClick,
  sx,
}: SplitScreenButtonProps): JSX.Element {
  return (
    <FaroTooltip
      title={enabled ? "Split screen" : "Split screen is unavailable"}
    >
      <ToggleButton
        selected={checked}
        value="splitscreen"
        aria-label="split screen"
        onClick={onClick}
        disabled={!enabled}
        disabledBackgroundColor={grey[1000]}
        sx={{
          ...sx,
          textTransform: "none",
        }}
      >
        <Stack direction="row" sx={{ alignItems: "center" }}>
          {checked ? (
            <CloseIcon sx={{ width: "18px", marginRight: "14px" }} />
          ) : (
            <SplitscreenStartIcon
              sx={{
                width: "18px",
                marginRight: "14px",
                ["&:hover"]: {
                  color: "white",
                },
              }}
            />
          )}

          <FaroText
            variant="bodyS"
            color="inherit"
            sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
          >
            Split screen
          </FaroText>
        </Stack>
      </ToggleButton>
    </FaroTooltip>
  );
}
